import { render } from "./TransactionCard.vue?vue&type=template&id=33c56ca9&scoped=true"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"

import "./TransactionCard.vue?vue&type=style&index=0&id=33c56ca9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c56ca9"]])

export default __exports__